import styled from 'styled-components';

/** Critical / Warning / Info, three across even on a phone. */
export const Counters = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 20px;
  margin: 32px 0 16px;

  @media (max-width: 800px) {
    gap: 8px;
    margin: 20px 0 12px;
  }
`;

/** The category tabs; they wrap rather than scroll, there are at most nine. */
export const Chips = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`;
